import { render } from "./StationFailuresEvent.vue?vue&type=template&id=55c86d50"
import script from "./StationFailuresEvent.vue?vue&type=script&lang=js"
export * from "./StationFailuresEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__